import useCurrency from '@/hooks/currency'
import useDates from '@/hooks/dates'
import { forwardRef } from 'react'
import { animated } from '@react-spring/web'
import styles from './BestOffferTicket.module.css'

// components
import Image from 'next/legacy/image'
import clsx from 'clsx'
import { parseISO } from 'date-fns'

export const offersTransitionConfig = {
  from: { transform: 'translate(0,-40px)', opacity: 0 },
  enter: { transform: 'translate(0,0px)', opacity: 1 },
  trail: 100,
  config: {
    duration: 0,
  },
}

export const BestOfferTicket = forwardRef(function Ticket(
  { bestOffer, style, onClick, className },
  ref
) {
  const { formatCurrency } = useCurrency()
  const { formatDate } = useDates()

  return (
    <animated.div
      className={clsx(styles.bestOffer, className)}
      onClick={onClick}
      style={style}
      ref={ref}
    >
      <section className="logo">
        <Image
          src={`https://nbg1.your-objectstorage.com/ulysse-web/airlines/${bestOffer.airline.code}.png`}
          width={37}
          height={37}
          alt={bestOffer.airline.name}
          title={bestOffer.airline.name}
        />
      </section>
      <section className="info">
        <header>
          <ul className="places">
            <li className="place origin">
              <span>De </span>
              <strong>{bestOffer.origin.city_name}</strong> (
              <small>{bestOffer.origin.iata_code})</small>
            </li>
            <li className="place destination">
              <span>Pour </span>
              <strong>{bestOffer.destination.city_name}</strong> (
              <small>{bestOffer.destination.iata_code})</small>
            </li>
          </ul>
          <div className="price">
            <small>À partir de</small>
            <strong>{formatCurrency(bestOffer.price, 'EUR')}</strong>
          </div>
        </header>
        <footer>
          <strong className="date">
            Du {formatDate(parseISO(bestOffer.departure_date), 'dd MMM')} au{' '}
            {formatDate(parseISO(bestOffer.return_date), 'dd MMM yyyy')}
          </strong>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              fillRule="evenodd"
              cliRrule="evenodd"
              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.4307 9.64645L10.2487 6.46447C10.0535 6.2692 9.73689 6.2692 9.54163 6.46447C9.34636 6.65973 9.34636 6.97631 9.54163 7.17157L11.8701 9.5H6.92331V10.5H11.8701L9.54163 12.8284C9.34636 13.0237 9.34636 13.3403 9.54163 13.5355C9.73689 13.7308 10.0535 13.7308 10.2487 13.5355L13.4307 10.3536C13.626 10.1583 13.626 9.84171 13.4307 9.64645Z"
              fill="#0F2041"
            ></path>
          </svg>
        </footer>
      </section>
    </animated.div>
  )
})

export default BestOfferTicket
